import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { scrollToElement } from '@project/shared/utils/scroll-to/js/scroll-to';

const classes = {
	scroller: 'js-m-slider-stage__scroller',
	list: 'js-m-slider-stage__list',
	item: 'js-m-slider-stage__item',
	falseItem: 'false-item',
	activeItem: 'state-m-slider-stage--item-is-active',
	activeCaption: 'state-m-slider-stage--caption-is-active',
	captionWrapper: 'js-m-slider-stage__caption-wrapper',
	caption: 'js-m-slider-stage__caption-item',
	dotButton: 'js-m-slider-stage__dot-button',
	dot: 'js-m-slider-stage__dot',
	activeDot: 'state-m-slider-stage--dot-is-active',
	dotWrapper: 'js-m-slider-stage__dots-wrapper',
	dotArea: 'js-m-slider-stage__dots',
	showArrow: 'state-m-slider-stage--arrow-is-shown',
	arrowLeft: 'js-m-slider-stage__arrow--left',
	arrowRight: 'js-m-slider-stage__arrow--right',
	link: 'js-m-slider-stage__item-link',
	pages: "js-m-slider-stage__pages",
	currentPage: "js-m-slider-stage__current-page",
	totalPage: "js-m-slider-stage__total-page",
	videoElement: 'js-m-slider-stage__video',
	ScrollDownLink: 'js-m-slider-stage__scroll-down-link',
};

@createModule('SliderStage')
/**
 * Breadcrumb module implementation.
 *
 * @author Christoph Merkelbach <christoph.merkelbach@namics.com>
 */
export class SliderStage extends TerrificSpec {
	$ctx: JQuery;
	$dot: JQuery;
	$dotButton: JQuery;
	$dotWrapper: JQuery;
	$dotArea: JQuery;
	$captionWrapper: JQuery;
	$caption: JQuery;
	$arrowLeft: JQuery;
	$arrowRight: JQuery;
	$scroller: JQuery;
	$items: JQuery;
	$list: JQuery;
	$links: JQuery;
	$pages: JQuery;
	$currentPage: JQuery;
	$totalPage: JQuery;
	$videoElement: JQuery;
	$ScrollDownLink: JQuery;
	itemsPerPage: Array<number>;
	_sliderPageIndex: number;
	sliderlength: number;
	dotIndex: number;

	start(resolve: Function) {
		this.initVars();

		$(window).on('resize', () => {
			this.setScrollerHeight();
		});

		this.initScroller();
		this.initNavigationArrows();
		this.setActiveDot(0);
		this.goToDotX(0);
		this.setScrollerHeight();

		setTimeout(() => {
			this.$captionWrapper.height(this.$caption.eq(0).innerHeight());
		}, 50);

		this.scrollToAnchor();

		resolve();
	}

	initVars() {
		this.$ctx = $(this._ctx);
		this.$arrowLeft = $(`.${classes.arrowLeft}`, this.$ctx);
		this.$arrowRight = $(`.${classes.arrowRight}`, this.$ctx);
		this.$scroller = $(`.${classes.scroller}`, this.$ctx);
		this.$items = $(`.${classes.item}`, this.$ctx);
		this.$list = $(`.${classes.list}`, this.$ctx);
		this.$links = $(`.${classes.link}`, this.$ctx);
		this.$pages = $(`.${classes.pages}`, this.$ctx);
		this.$currentPage = $(`.${classes.currentPage}`, this.$ctx);
		this.$totalPage = $(`.${classes.totalPage}`, this.$ctx);
		this.$videoElement = $(`.${classes.videoElement}`, this.$ctx);
		this.$dot = $(`.${classes.dot}`, this.$ctx);
		this.$dotButton = $(`.${classes.dotButton}`, this.$ctx);
		this.$dotWrapper = $(`.${classes.dotWrapper}`, this.$ctx);
		this.$dotArea = $(`.${classes.dotArea}`, this.$ctx);
		this.$captionWrapper = $(`.${classes.captionWrapper}`, this.$ctx);
		this.$caption = $(`.${classes.caption}`, this.$ctx);
		this.$ScrollDownLink = $(`.${classes.ScrollDownLink}`, this.$ctx);
		this.sliderPageIndex = 0;
		this.dotIndex = 0;
		this.sliderlength = this.$items.length;
	}

	initNavigationArrows() {
		// bind event on the left arrow  to go to active page minus 1 (to left)
		this.$arrowLeft.on('click',
			(e: Event) => {
				this.evtClickSkipBackOrForth(e, -1);
			});

		// bind event on the right arrow to go to active page plus 1 (to right)
		this.$arrowRight.on('click', 
			(e: Event) => {
				this.evtClickSkipBackOrForth(e, 1);
			});
	}

	initScroller() {
		this.initPageDots(0);

		var itemWidth = $(window).width();
		this.$items.width(itemWidth);
		this.$list.append(this.$items.first().clone().addClass(classes.falseItem).removeClass(classes.activeItem).width(itemWidth));
		this.$list.prepend(this.$items.last().clone().addClass(classes.falseItem).width(itemWidth));
		this.$list.css("left", -itemWidth );

		this.$totalPage.text(this.sliderlength);
		this.$currentPage.text(1);
		if (this.sliderlength == 3) {
			this.$pages.addClass("pages-pc-hide")
		} else if (this.sliderlength == 2) {
			this.$pages.addClass("pages-mobile-visible")
		} else if(this.sliderlength < 2) {
			this.$pages.hide();
			this.$arrowLeft.parent().hide();
			this.$dotWrapper.parent().hide();
			this.$captionWrapper.addClass("alone")
		}
	}

	initPageDots(numberOfItemsPerPage: number) {
		this.$dot.each((index: number, elem: HTMLElement) => {
			$(elem).on('click', (e: Event) => {
				this.evtClickDot(e, index);
			});
		});
	}

	setScrollerHeight() {
		var itemWidth = $(window).width();
		this.$items.width(itemWidth);
		$(".false-item").width(itemWidth);
		this.$list.css("left", -( this.sliderPageIndex + 1 ) * itemWidth );
		this.$captionWrapper.height(this.$caption.eq(this.sliderPageIndex).innerHeight());
	}

	setActiveDot(pageNumber: number) {
		this.$caption
			.removeClass(classes.activeCaption)
			.eq(pageNumber)
			.addClass(classes.activeCaption);	

		this.$videoElement.trigger('pause');
		this.$items.eq(pageNumber).find("video").trigger('play');

		this.$captionWrapper.height(this.$caption.eq(pageNumber).innerHeight());

		this.$currentPage.text(pageNumber + 1);

		this.$dot
		.removeClass(classes.activeDot)
		.eq(pageNumber)
		.addClass(classes.activeDot);

		var sliderlength = this.sliderlength;
		if(sliderlength < 3){
			this.$dotArea.addClass("scroll-inactive");
		} else if(sliderlength == 3){
			this.$dotArea.addClass("scroll-tabet-active");
		} else if(sliderlength > 3){
			this.$dotArea.addClass("scroll-active");
		};

		this.sliderPageIndex = pageNumber;
	}

	goToPageX(pageNumber: number) {
		var itemPerWidth = 0 - $(window).width();
		var me=this;
		this.$list.animate({
			"left": ( pageNumber + 1 ) * itemPerWidth
		}, 500, () => {
			if (pageNumber < 0) {
				pageNumber = this.sliderlength - 1;
				this.$list.css("left", this.sliderlength * itemPerWidth );
			} else if (pageNumber == this.sliderlength) {
				pageNumber = 0;
				this.$list.css('left', itemPerWidth);
			}
			me.setActiveDot(pageNumber);
			me.sliderPageIndex = pageNumber;
		});
	}

	goToDotX(nextIndex: number) {
		var sliderlength = this.sliderlength;
		this.dotIndex = nextIndex;
		if(sliderlength > 2){
			var oneDot = nextIndex;
			var zeroDot = nextIndex-1;
			var twoDot = nextIndex + 1;
			var threeDot = nextIndex + 2;
			var fourDot = nextIndex + 3;

			if (twoDot == sliderlength) {
				twoDot = 0;
				threeDot = 1;
				fourDot = 2;
			} else if (threeDot == sliderlength) {
				threeDot = 0;
				fourDot = 1;
			} else if (fourDot == sliderlength) {
				fourDot = 0;
			}
			this.$dot.removeClass("pc-prev-zero pc-next-one pc-next-two pc-next-three pc-next-four");
			this.$dot.eq(zeroDot).addClass("pc-prev-zero");
			this.$dot.eq(oneDot).addClass("pc-next-one");
			this.$dot.eq(twoDot).addClass("pc-next-two");
			this.$dot.eq(threeDot).addClass("pc-next-three");
			setTimeout(() => {
				this.$dot.eq(fourDot).addClass("pc-next-four");
			}, 300);
		};
		
	}
	/**
	 * Click Event for Dots in Slider-Gallery
	 * @param {event} e event
	 * @param {number} index index
	 * @returns {void} return nothing
	 */
	evtClickDot(e: any, index: number) {
		this.goToPageX(index);
	}

	/**
	 * Click Event for Skip Back/Next slider in Slider-Gallery
	 * @param {event} e event
	 * @param {number} sliderIdxOffset Positive integer value will increase and negative will decrease the slider page
	 * @returns {void} return nothing
	 */
	evtClickSkipBackOrForth(e: Event, sliderIdxOffset: number) {
		if (sliderIdxOffset<0) {
			this.$dotArea.addClass('scroll-left');
			setTimeout(() => {
				if (this.dotIndex == 0) {
					const nextIndex = this.sliderlength-1;
					setTimeout(() => {
						this.goToDotX(nextIndex);
					}, 50);
				} else {
					const nextIndex = this.dotIndex + sliderIdxOffset;
					this.goToDotX(nextIndex);
				}
			}, 50);
		} else {
			this.$dotArea.removeClass('scroll-left');
			setTimeout(() => {
				if (this.dotIndex == this.sliderlength-1) {
					const nextIndex = 0;
					this.goToDotX(nextIndex);
				} else {
					const nextIndex = this.dotIndex + sliderIdxOffset;
					this.goToDotX(nextIndex);
				}
			}, 50);
		}
		const nextPage = this.sliderPageIndex + sliderIdxOffset;
		this.goToPageX(nextPage);
	}


	/**
	 * Slider Page Index
	 * @returns {void} return nothing
	 */
	get sliderPageIndex(): number {
		return this._sliderPageIndex;
	}

	/**
	 * Slider Page Index
	 * @param {number} value index
	 * @returns {void} return nothing
	 */
	set sliderPageIndex(value: number) {
		this._sliderPageIndex = value;
	}

	/**
	 * Scroll to top of the document
	 * @returns {void}
	 */
	
	scrollToAnchor() {
		var scrollAnchor = this.$ScrollDownLink.attr("href");
		this.$ScrollDownLink.on('click', () => {
			if (typeof(this.$ScrollDownLink.attr("href"))=="undefined") {
				scrollToElement(this.$ScrollDownLink, false, -20, undefined, true);
			} else {
				scrollToElement($(scrollAnchor), false, 0, undefined, true);
			}
		});
	}

	/**
	 * back-to-top button should contain the 'a-button--anchor' css class that comes from the button modifier 'top'
	 * to separate its click event
	 * @returns {boolean} boolean
	 */

	stop() {}
}
